//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../no/ugmath.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"DecalStickersInShadedDisplay",1,0],[0,"EnableFlatShading",1,0],[0,"EnableMaterialsInShadedMode",1,0],[0,"FinishEffectInShadedMode",1,0],[0,"FullSceneAntialiasing",1,0],[0,"GlobalFinish",1,0],[0,"LineAntialiasing",1,0],[0,"ReduceEdgeBleedThrough",1,0],[0,"Translucency",1,0]],[[["screenX","screenY","view","viewPoint"],"GetViewFromPoint",{},2,0]],[]];
SPLM.Preferences.SessionVisualizationVisual = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.SessionVisualizationVisual";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.SessionVisualizationVisual.FinishEffect = Object.freeze({
    "GlobalFinish" : "GlobalFinish", "PartShininess" : "PartShininess"});

SPLM.Preferences.SessionVisualizationVisual.GlobalFinishType = Object.freeze({
    "Flat" : "Flat", "Glossy" : "Glossy", "Matte" : "Matte", "Satin" : "Satin"});

export default SPLM;